import { Fragment } from 'react';
import styles from './StatsBanner.module.css';

const STATS = [
  { num: '16+',  label: 'QR Types' },
  { num: '4',    label: 'Download Formats' },
  { num: '100%', label: 'Free Forever' },
  { num: '0',    label: 'Signup Required' },
];

export default function StatsBanner({ variant = 'default' }) {
  return (
    <div className={`${styles.wrap} ${variant === 'dark' ? styles.dark : ''}`}>
      <div className="container">
        <div className={styles.grid}>
          {STATS.map((s, i) => (
            <Fragment key={s.label}>
              <div className={styles.item}>
                <div className={styles.num}>{s.num}</div>
                <div className={styles.label}>{s.label}</div>
              </div>
              {i < STATS.length - 1 && <span className={styles.divider} aria-hidden="true" />}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}